import React, {useRef, useState} from "react";
import IconButton from "@mui/material/IconButton";
import PrintIcon from "@mui/icons-material/Print";
import {fetchExpenseFile} from "../../api/api";
import {LoadingItem} from "../loading-item/LoadingItem";
import {CircularProgress} from "@mui/material";


export const ExpensePrintButton = (props: { id: string, fileName: string }) => {
    const [isLoading, setIsLoading] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const handlePrint = async () => {
        try {
            setIsLoading(true);
            const blob = await fetchExpenseFile(props);
            const blobUrl = URL.createObjectURL(blob);

            if (iframeRef.current) {
                iframeRef.current.src = blobUrl;
                iframeRef.current.onload = () => {
                    const contentWindow = iframeRef.current?.contentWindow;
                    if (contentWindow) {
                        contentWindow.focus(); // Focus the iframe content
                        contentWindow.print(); // Trigger print dialog
                    } else {
                        console.log("no contentWindow");
                    }
                    URL.revokeObjectURL(blobUrl);
                };
            }
        } catch (error) {
            console.error('Error fetching or printing the file:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <IconButton onClick={handlePrint} disabled={isLoading}>
                {isLoading ? <LoadingItem><CircularProgress/></LoadingItem> : <PrintIcon/>}
            </IconButton>
            <iframe
                ref={iframeRef}
                style={{display: 'none'}}
                title="Hidden Print Frame"
            />
        </>
    );
};